module.exports = __webpack_public_path__ + "img/be.f1e78c8b.svg";